import { lazy } from 'react';

const PROGRAM_UUIDS = {
    RAROS_EM_FOCO: import.meta.env.VITE_PROGRAMA_RAROS_EM_FOCO_PSD || '',
    // NOVO_CLIENTE: 'uuid-aqui-ou-env',
};

const REGISTRY = {
    [PROGRAM_UUIDS.RAROS_EM_FOCO]: lazy(() => import('./LoginPersonalizadosProgramas/RarosEmFocoPSD/index')),
    
    // Exemplo futuro:
    // [PROGRAM_UUIDS.NOVO_CLIENTE]: lazy(() => import('./LoginPersonalizadosProgramas/NovoCliente/index')),
};

/**
 * Retorna o componente Lazy correspondente ao UUID ou null se não existir
 * @param {string} uuid 
 */
export const getCustomLoginComponent = (uuid) => {
    if (!uuid) return null;
    return REGISTRY[uuid] || null;
};
